"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PaginationTable_1 = require("../PaginationTable");
var customer_1 = require("../../api/customer");
var react_1 = require("react");
var AddCustomerButton_1 = require("./modals/AddCustomerButton");
require("../../styles/CustomerListPage.css");
var authConfig_1 = require("../../authConfig");
var msal_browser_1 = require("@azure/msal-browser");
var msal_react_1 = require("@azure/msal-react");
var reactstrap_1 = require("reactstrap");
var CustomerEditForm_1 = require("./modals/CustomerEditForm");
var CustomerDeleteButton_1 = require("./modals/CustomerDeleteButton");
var handleEdit = function (row) {
    console.log(row);
};
var handleDelete = function (row) { };
var CustomerListPage = function (props) {
    var authRequest = __assign({}, authConfig_1.loginRequest);
    var inProgress = msal_react_1.useMsal().inProgress;
    var formRef = react_1.useRef();
    /*const columns = customerListColumns*/ ;
    var columns = [
        {
            Header: 'Logo',
            accessor: 'profilepic',
            Cell: function (row) { return (React.createElement("div", { id: "Logo" },
                React.createElement("img", { className: "logo-default logo-image", src: row.value != null && row.value != '' ? row.value : "./images/companyDefault.svg" }))); }
        },
        {
            Header: 'Name',
            accessor: 'name'
        },
        {
            Header: 'Email',
            accessor: 'email'
        },
        {
            Header: 'Description',
            accessor: 'description'
        },
        {
            Header: 'Industry',
            accessor: 'industry'
        },
        {
            Header: 'Action',
            accessor: 'id',
            Cell: function (row) { return (React.createElement("div", { className: "action-button" },
                React.createElement("a", { style: { padding: 0 }, className: "padding-default", href: '/customer-detail/' + row.value },
                    React.createElement("img", { src: "./visibility.svg", className: "font-icon" })),
                React.createElement(reactstrap_1.Button, { style: { padding: 0 }, color: "link", onClick: function () { return toggle(row.value); } },
                    React.createElement("a", { className: "padding-default" },
                        React.createElement("img", { src: "./edit.svg", className: "font-icon" }))),
                React.createElement(CustomerDeleteButton_1.default, { id: row.value }))); }
            //Cell: (row: any) => {
            //    return React.createElement("div", { className: "license-action" },
            //        [
            //            React.createElement(<a style={{ padding: 0 }} className="padding-default" href={'/customer-detail/' + row.value}><img src="./visibility.svg" className="font-icon" /></a>, null),
            //            React.createElement(LicenseDeleteButton, { id: row.value, list: licenseData, userId: graphData.id, modalCallback: deleteLicenseDataCallBack }, null)
            //        ]);
            //}
        }
    ];
    var _a = react_1.useState(new Array()), list = _a[0], setList = _a[1];
    var _b = react_1.useState(false), isLoaded = _b[0], setIsLoaded = _b[1];
    var _c = react_1.useState(false), modal = _c[0], setModal = _c[1];
    var _d = react_1.useState(0), id = _d[0], setId = _d[1];
    //const [data, setData] = useState(null);
    var _e = react_1.useState({
        id: 0,
        name: "",
        displayName: "",
        email: "",
        phoneNumber: "",
        status: "",
        address: { firstLine: "", secondLine: "", state: "" },
        industry: "",
        description: "",
        language: "",
        country: "",
        createdAt: "",
        modifiedAt: "",
        profilepic: ""
    }), data = _e[0], setData = _e[1];
    var onLoad = function () {
        if (id && modal) {
            customer_1.fetchCustomer(id.toString()).then(function (result) {
                setData(result);
                setIsLoaded(true);
            }).catch(console.error);
        }
        else {
            customer_1.fetchCustomers().then(function (data) {
                setList(data.list);
                setIsLoaded(true);
            }).catch(console.error);
        }
    };
    var pushToList = function (item) {
        var newList = list;
        newList.push(item);
        setList(__spreadArray([], newList));
    };
    react_1.useEffect(function () {
        if (!isLoaded && inProgress === msal_browser_1.InteractionStatus.None)
            onLoad();
    }, [list, setList, isLoaded, setIsLoaded, inProgress, id, setId, modal, setModal]);
    var toggle = function (id) {
        setModal(!modal);
        if (id)
            setId(id);
    };
    var updateCustomerCallback = function () {
        setList(__spreadArray([], new Array()));
        toggle(0);
    };
    var updateNewCustomerCallback = function () {
        setList(__spreadArray([], new Array()));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(msal_react_1.MsalAuthenticationTemplate, { interactionType: msal_browser_1.InteractionType.Redirect, authenticationRequest: authRequest },
            React.createElement("div", { className: "card-header" },
                React.createElement("div", null,
                    React.createElement("h5", { className: "card-title" }, "List of Customers")),
                React.createElement(AddCustomerButton_1.default, { callback: updateNewCustomerCallback })),
            React.createElement("div", { className: "tableContainer" }, isLoaded ? React.createElement(PaginationTable_1.PaginationTable, { columns: columns, data: list }) : React.createElement(React.Fragment, null, "Loading...")),
            React.createElement(reactstrap_1.Modal, { isOpen: modal, toggle: toggle, size: "lg", centered: true },
                React.createElement(reactstrap_1.ModalHeader, { toggle: toggle }, "Edit Customer Profile"),
                React.createElement(reactstrap_1.ModalBody, null,
                    React.createElement(CustomerEditForm_1.default, { data: data, modalCallback: updateCustomerCallback, ref: formRef })),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement(reactstrap_1.Button, { color: "primary", onClick: toggle }, "Cancel"),
                    ' ',
                    React.createElement(reactstrap_1.Button, { color: "secondary", onClick: function () { return formRef.current.submitForm(); } }, "Confirm"))))));
};
exports.default = CustomerListPage;
//# sourceMappingURL=CustomerListPage.js.map